import config from '../../config'

const geoserverURL = `${config.geoserver.geoserverURL}/${config.geoserver.geoserverWorkspace}/wps`

export default function(geometryStr, layer, calcPercentages) {
  const file = getRequestBody(geometryStr, layer, calcPercentages)

  return fetch(geoserverURL, {
    method: 'POST',
    body: file,
    headers: new Headers({'Content-Type': 'application/xml'})
  })
  .then(res => res.json())
}

function getRequestBody(geometryStr, layer, calcPercentages) {
  const workspace = config.geoserver.geoserverWorkspace
  const { 
    name, 
    /*nativeBoundingBox: { minx, maxx, miny, maxy, crs: { $: projection } }*/
  } = layer

	return `<?xml version="1.0" encoding="UTF-8"?><wps:Execute version="1.0.0" service="WPS" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns="http://www.opengis.net/wps/1.0.0" xmlns:wfs="http://www.opengis.net/wfs" xmlns:wps="http://www.opengis.net/wps/1.0.0" xmlns:ows="http://www.opengis.net/ows/1.1" xmlns:gml="http://www.opengis.net/gml" xmlns:ogc="http://www.opengis.net/ogc" xmlns:wcs="http://www.opengis.net/wcs/1.1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xsi:schemaLocation="http://www.opengis.net/wps/1.0.0 http://schemas.opengis.net/wps/1.0.0/wpsAll.xsd">
    <ows:Identifier>vec:IntersectionFeatureCollection</ows:Identifier>
    <wps:DataInputs>
      <wps:Input>
        <ows:Identifier>first feature collection</ows:Identifier>
        <wps:Reference mimeType="text/xml" xlink:href="http://geoserver/wfs" method="POST">
        <wps:Body>
          <wfs:GetFeature service="WFS" version="1.0.0" outputFormat="GML2" xmlns:${workspace}="/${workspace}">
            <wfs:Query typeName="${name}"/>
          </wfs:GetFeature>
        </wps:Body>
        </wps:Reference>
      </wps:Input>
      <wps:Input>
        <ows:Identifier>second feature collection</ows:Identifier>
        <wps:Data>
          <wps:ComplexData mimeType="application/json"><![CDATA[
            ${geometryStr}
          ]]></wps:ComplexData>
        </wps:Data>
      </wps:Input>
      <wps:Input>
        <ows:Identifier>intersectionMode</ows:Identifier>
        <wps:Data>
          <wps:LiteralData>INTERSECTION</wps:LiteralData>
        </wps:Data>
      </wps:Input>
      <wps:Input>
        <ows:Identifier>percentagesEnabled</ows:Identifier>
        <wps:Data>
          <wps:LiteralData>${calcPercentages}</wps:LiteralData>
        </wps:Data>
      </wps:Input>
      <wps:Input>
        <ows:Identifier>areasEnabled</ows:Identifier>
        <wps:Data>
          <wps:LiteralData>False</wps:LiteralData>
        </wps:Data>
      </wps:Input>
    </wps:DataInputs>
    <wps:ResponseForm>
      <wps:RawDataOutput mimeType="application/json">
        <ows:Identifier>result</ows:Identifier>
      </wps:RawDataOutput>
    </wps:ResponseForm>
  </wps:Execute>`
}


// WEBPACK FOOTER //
// ./src/api/wps/Intersection.js